<app-ticket-list-item *ngFor="let item of (items$|async)" [item]="item" (click)="openItem(item)"></app-ticket-list-item>